import type { InningScorecard } from "../../leaguesHome/tournaments/tournamentsDetails/matches/matchesDetails/types/matchDetails.d";
import { batterName } from "./helpers";

export type CurrentBatter = { id: string; name: string; team?: string | null; role: "STRIKER" | "NON-STRIKER"; runs: number; balls: number; fours: number; sixes: number; out: boolean };

/** The two batters at the crease, with their scorecard figures. Empty between innings or before the first ball. */
export const creaseBatters = (inn?: InningScorecard | null): CurrentBatter[] => {
  if (!inn) return [];
  const list = inn.battingScoreCardResponseList ?? [];
  const find = (status: string, id?: string | null) => list.find((b) => b.status === status) ?? list.find((b) => !!id && b.playerId === id);
  const out: CurrentBatter[] = [];
  ([["STRIKER", find("STRIKER", inn.striker?.playerId)], ["NON-STRIKER", find("NON_STRIKER", inn.nonStriker?.playerId)]] as const).forEach(([role, b]) => {
    if (b) out.push({ id: b.playerId, name: batterName(b), team: inn.battingTeamName, role, runs: b.run ?? 0, balls: b.balls ?? 0, fours: b.fours ?? 0, sixes: b.six ?? 0, out: false });
  });
  return out;
};
